var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px"}},[_c('v-btn',{staticClass:"primary",attrs:{"dark":"","text":""},on:{"click":_vm.showDialog}},[_vm._v("建立代辦合約書")]),_vm._v(" "),_c('agent-contract-view',{attrs:{"agent-contract-dialog":_vm.agentContractDialog},on:{"saveContract":_vm.saveContract}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e5d600","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgentContractToolView.vue
// module id = null
// module chunks = 